"use client";
import CommonImage from "@/components/common/image/CommonImage";
import dynamic from "next/dynamic";
import { motion } from "framer-motion";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaPlay } from "react-icons/fa";
import HomePageService from "@/services/api/HomeService";
import VimeoPlayer from "@/components/common/Player/VimeoPlayer";
import CourseVideo from "@/components/common/Player/CourseVideo";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import { getYoutubeThumbnailUrl } from "@/utils/youtube";
import Link from "next/link";
import SkeletonHeroSection from "@/components/common/skeletons/SkeletonHeroSection";
import HeroSectionVideoModal from "@/components/common/Modal/HeroSectionVideoModal";
import { usePublicFetch } from "@/hook/usePublicFetch";
export default function HeroSection({ siteSetting  }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  return (
    <>
      <section className="hero-section section_short-padding">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 hero-content">
            <div className="left-part">
              <div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="hero-text"
              >
                <h1 className="main-title">
                  <span className="highlighted">
                    {siteSetting?.banner_heading_blue}
                    {/* আপনার স্বপ্নের বিশ্ববিদ্যালয় */}
                  </span>
                  {/* {siteSetting?.banner_heading_blue} */}{" "}
                  {siteSetting?.banner_heading_black}
                </h1>
              </div>
              <div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <div className="hero-description">
                  <p>
                    {siteSetting?.banner_sub_heading}
                    {/* ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ
                      শিক্ষকদের গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং
                      টপিকভিত্তিক অনুশীলনের মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের
                      চ্যাম্পিয়ন। */}
                  </p>
                </div>
              </div>
              <div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="hero-btns"
              >
                <Link
                  href="/courses/all"
                  className="btn-outline btn-outline-hero"
                >
                  <Image
                    src="/images/admission-icon/trending-course.png"
                    alt="Icon"
                    width={20}
                    height={20}
                    className="btn-icon"
                  />
                  সকল কোর্স
                </Link>
                {siteSetting?.trendy_button_title && (
                  <a
                    href={siteSetting?.trendy_button_link}
                    className="primary-btn primary-btn-hero"
                  >
                    <Image
                      src="/images/admission-icon/book-icon.png"
                      alt="Icon"
                      width={20}
                      height={20}
                      className="btn-icon"
                    />
                    {siteSetting.trendy_button_title}
                  </a>
                )}
              </div>
              <Image
                src="/images/home/hero-bg-shpes.png"
                alt="Icon"
                width={300}
                height={300}
                className="bg-box-pattern block [.dark_&]:hidden"
              />
              <Image
                src="/images/home-dark/hero-bg-shpes.png"
                alt="Icon"
                width={300}
                height={300}
                className="bg-box-pattern hidden [.dark_&]:block"
              />
            </div>
            <div className="right-part">
              <div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="hero-image"
              >
                <CommonImage
                  src={
                    // siteSetting?.welcome_video_thumble_url ??
                    "/images/home/hero.png"
                  }
                  alt="Hero Image"
                  className="hero-img"
                />
                <div className="hero-image-playbtn">
                  {/* test icon */}
                  <div
                    className="hero-play will-change-transform animate-[spin_10s_linear_infinite]"
                    onClick={showModal}
                  >
                    <div className="hero-play-container">
                      <div className="text-wrap circle-text absolute inset-1 origin-center  pointer-events-none">
                        <svg
                          viewBox="0 0 200 200"
                          className="w-full h-full -rotate-90"
                        >
                          <defs>
                            <path
                              id="circlePath"
                              d="M100,100 m-75,0 a75,75 0 1,1 150,0 a75,75 0 1,1 -150,0"
                            />
                          </defs>
                          <text className="fill-white uppercase tracking-[6px] text-[20px] select-none font-poppins">
                            <textPath xlinkHref="#circlePath">
                              • WATCH VIDEO • WATCH VIDEO
                            </textPath>
                          </text>
                        </svg>
                      </div>

                      <div className="absolute inset-0 grid place-items-center">
                        <div className="icon-wrap">
                          <FaPlay className="play-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* test icon */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <HeroSectionVideoModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setting={siteSetting}
        />
        <Image
          src={"/images/admission-icon/soft-star.png"}
          alt="icon"
          className="hero-star block [.dark_&]:hidden"
          width={22}
          height={22}
        />
        <Image
          src={"/images/admission-icon/soft-star.png"}
          alt="icon"
          className="hero-star2 block [.dark_&]:hidden"
          width={22}
          height={22}
        />
        <Image
          src={"/images/home-dark/soft-star.png"}
          alt="icon"
          className="hero-star hidden [.dark_&]:block"
          width={22}
          height={22}
        />
        <Image
          src={"/images/home-dark/soft-star.png"}
          alt="icon"
          className="hero-star2 hidden [.dark_&]:block"
          width={22}
          height={22}
        />
      </section>
    </>
  );
}
